import Container from "./containers/Container";
//import { reducers, sagas } from "./reduxSagas";

const Deposits = {
  Container,
};

export { Deposits };